import React from "react";
import img01 from "../../assets/img/team/jkr-1.jpeg";
import img02 from "../../assets/img/team/jkr-2.jpeg";
import img03 from "../../assets/img/team/jkr-3.jpeg";
import img04 from "../../assets/img/team/jkr-4.jpeg";
import img05 from "../../assets/img/team/jkr-5.jpeg";
import TeamOneItem from "./TeamOneItem";

const TeamOne = () => {
  const team_members = [
    {
      src: img01,
      name: "Cameron Williamson",
      designation: "Founder & CO",
    },
    {
      src: img02,
      name: "Eleanor Pena",
      designation: "Head of Design",
    },
    {
      src: img03,
      name: "Bessie Cooper",
      designation: "Vp People",
    },
    {
      src: img04,
      name: "Darlene Robertson",
      designation: "Product Manager",
    },
    {
      src: img05,
      name: "Jacob Jones",
      designation: "Marketer",
    },
  ];

  return (
    <section id="about-us" className="team-area pt-130">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-6">
            <div className="section-title text-center mb-70">
              <span className="sub-title">About Us</span>
              <h2 className="title">
                The Leadership <br /> <span>Team</span>
              </h2>
            </div>
          </div>
        </div>

        <div className="row justify-content-center">
          {team_members.map((member, index) => (
            <div key={index} className="col-xl-3 col-md-4 col-sm-6">
              <TeamOneItem item={member} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamOne;
